import Vue from "vue";
import Vuetify from "vuetify";
import "material-design-icons-iconfont/dist/material-design-icons.css";
import editPicksIcon from "../components/icons/editPicksIcon.vue";
import editDrivesIcon from "../components/icons/editDrivesIcon.vue";
import JumpToPickIcon from "../components/icons/jumpToPickIcon.vue";
import editJacShaftIcon from "../components/icons/editJacShaftIcon.vue";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#888888", // #E53935
        secondary: "#123456" // #FFCDD2
      }
    }
  },
  icons: {
    iconfont: "md",
    values: {
      editPicks: { component: editPicksIcon },
      editDrives: { component: editDrivesIcon },
      jumpToPick: { component: JumpToPickIcon },
      editJacShaft: { component: editJacShaftIcon }
    }
  }
});
